<script setup>
import commonUtils from "@/utils/commonUtils";

const props = defineProps({
  promotionFlights: {},
  showFlightPromotionUserRating: {},
});

const baseUrl = "/api/v3/content/collections/images";
</script>
<template>
  <section
    v-if="
      commonUtils.sortByParams(promotionFlights, 'sequenceNumber') &&
      commonUtils.sortByParams(promotionFlights, 'sequenceNumber').length > 0
    "
    id="explore_area"
    class="section_padding_top"
  >
    <div class="container">
      <!-- Section Heading -->
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="section_heading_center">
            <h2>{{ $t("explore-our-hot-deals") }}</h2>
          </div>
        </div>
      </div>

      <!-- 数据展示-->
      <div class="row">
        <div class="col-lg-12">
          <div id="nav-tabContent" class="tab-content">
            <!-- Flights-->
            <div
              id="nav-tours"
              aria-labelledby="nav-tours-tab"
              class="tab-pane fade show active"
              role="tabpanel"
            >
              <div class="row">
                <div
                  v-for="(
                    promotionFlight, promotionFlightIndex
                  ) in commonUtils.sortByParams(
                    promotionFlights,
                    'sequenceNumber'
                  )"
                  :key="promotionFlightIndex"
                  class="col-lg-3 col-md-6 col-sm-6 col-12"
                >
                  <div class="theme_common_box_two img_hover">
                    <div class="theme_two_box_img">
                      <a
                        v-if="promotionFlight.image"
                        :herf="promotionFlight.links"
                      >
                        <img
                          :src="baseUrl + promotionFlight.image.url"
                          alt="img"
                          style="width: 100%; height: 222px; object-fit: cover"
                        />
                      </a>
                      <p>
                        <i class="fas fa-map-marker-alt"></i
                        >{{ promotionFlight.address }}
                      </p>
                    </div>
                    <div class="theme_two_box_content">
                      <h4>
                        <a :herf="promotionFlight.links">
                          {{ promotionFlight.description }},
                          {{ promotionFlight.countryName }}</a
                        >
                      </h4>
                      <p v-if="showFlightPromotionUserRating">
                        <span class="review_rating"
                          >{{ promotionFlight.userRating }}/{{
                            promotionFlight.totalRating
                          }}
                          {{ $t("excellent") }}</span
                        >
                        <!--                        <span class="review_count">(1214 reviewes)</span>-->
                      </p>
                      <h3>
                        {{ $t("price-starts-from") }}
                        {{ promotionFlight.currency }}
                        {{ promotionFlight.amount }}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
